// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2vKi2","alert":"SettungsInbox_alert__3fjXZ"};